theme.headerSticky = (function () {
  function ScrollSticky(e) {
    const headerStickyWrapper = document.querySelector("header");
    const headerStickyTarget = document.querySelector(".header__sticky");
    if (headerStickyTarget) {
      const headerHeight = headerStickyWrapper.clientHeight;
      const mainHederHeight = `${headerHeight}px`;
      // console.log("MINNNNNNNNNNNNNNNNNNNNNNNNN", mainHederHeight);

      window.addEventListener("scroll", function () {
        if (window.scrollY >= headerHeight) {
          headerStickyTarget.classList.add("sticky");
        } else {
          headerStickyTarget.classList.remove("sticky");
        }
      });
    }
  }
  return ScrollSticky;
})();
